import { PureFunctional, React } from '../../react';

import cx from './style.less';

export interface IButtonProps {
  active?: boolean;
  inverse?: boolean;
  fill?: boolean;
  title?: string;
  onClick?: any;
}

export default PureFunctional<IButtonProps>(`TabsButton`)(
  ({ active, inverse, fill, title, onClick }) => (
    <button aria-label={title}
        tabIndex={0} 
        className={cx('button', { active, inverse, fill })} onClick={onClick}>
    {title}
    </button>
  ));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/tabs/button.tsx